"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class SeatSearchResponse extends common_1.PaginatedResponse {
}
exports.SeatSearchResponse = SeatSearchResponse;
//# sourceMappingURL=seat-search.response.js.map